import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=c2feb278&"
import script from "./FormButtons.vue?vue&type=script&lang=ts&"
export * from "./FormButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports